module.exports = __webpack_public_path__ + "img/10.518f646b.png";